import type { EarnCatalogEvent } from '../earnEventsCatalog';
import type { EarnFilter, RewardsNavItem, RewardsSection } from './rewardsPageTypes';

export const getSectionByPath = (path: string): RewardsSection => {
  if (path.endsWith('/earn')) return 'earn';
  if (path.endsWith('/contest')) return 'contest';
  if (path.endsWith('/referrals')) return 'referrals';
  if (path.endsWith('/social-submissions')) return 'social';
  return 'earn';
};

export const filterEarnList = (evts: EarnCatalogEvent[], earnFilter: EarnFilter) => {
  if (earnFilter === 'available') return evts.filter((e) => !e.completed);
  if (earnFilter === 'completed') return evts.filter((e) => !!e.completed);
  return evts;
};

export const isRewardsNavActive = (
  item: RewardsNavItem,
  _pathname: string,
  activeSection: RewardsSection
) => activeSection === item.id;

